var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwitch01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.1 109.854 16 16",
    enableBackground: "new 78.1 109.854 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M90.725,109.854h-9.25c-1.861,0-3.375,1.515-3.375,3.375v0.25c0,1.86,1.514,3.375,3.375,3.375h9.25 c1.861,0,3.375-1.515,3.375-3.375v-0.25C94.1,111.369,92.586,109.854,90.725,109.854z M93.1,113.479 c0,1.31-1.065,2.375-2.375,2.375h-9.25c-1.31,0-2.375-1.065-2.375-2.375v-0.25c0-1.31,1.065-2.375,2.375-2.375h9.25 c1.31,0,2.375,1.065,2.375,2.375V113.479z M82.184,111.104c-1.286,0-2.333,1.047-2.333,2.333c0,1.287,1.047,2.334,2.333,2.334 s2.333-1.047,2.333-2.334C84.517,112.151,83.47,111.104,82.184,111.104z M82.184,114.771c-0.735,0-1.333-0.599-1.333-1.334 c0-0.734,0.598-1.333,1.333-1.333s1.333,0.599,1.333,1.333C83.517,114.173,82.919,114.771,82.184,114.771z M90.725,118.854h-9.25 c-1.861,0-3.375,1.515-3.375,3.375v0.25c0,1.86,1.514,3.375,3.375,3.375h9.25c1.861,0,3.375-1.515,3.375-3.375v-0.25 C94.1,120.369,92.586,118.854,90.725,118.854z M93.1,122.479c0,1.31-1.065,2.375-2.375,2.375h-9.25 c-1.31,0-2.375-1.065-2.375-2.375v-0.25c0-1.31,1.065-2.375,2.375-2.375h9.25c1.31,0,2.375,1.065,2.375,2.375V122.479z  M90.016,119.937c-1.286,0-2.333,1.047-2.333,2.334c0,1.286,1.047,2.333,2.333,2.333s2.333-1.047,2.333-2.333 C92.349,120.984,91.302,119.937,90.016,119.937z M90.016,123.604c-0.735,0-1.333-0.599-1.333-1.333 c0-0.735,0.598-1.334,1.333-1.334s1.333,0.599,1.333,1.334C91.349,123.006,90.751,123.604,90.016,123.604z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwitch01);
export default __webpack_public_path__ + "static/media/icon_switch-01.b5cfab10d23d7efdfea358ac985615e7.svg";
export { ForwardRef as ReactComponent };